import { generateClearResourceAction, generateStoreResourceAction } from '../generators/resource.actions';

import * as constants from './subscription.constants';
import * as types from './subscription.types';

export const storeSubscription = generateStoreResourceAction<types.ISubscription>(constants.STORE_SUBSCRIPTION);
export const clearSubscription = generateClearResourceAction(constants.CLEAR_SUBSCRIPTION);
